// Order form validation

import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  address: yup.string().trim().required('Câmp obligatoriu').max(255, 'Lungime maximă 255 caractere'),
  latitude: yup.number('Câmp numeric').required('Câmp obligatoriu'),
  longitude: yup.number('Câmp numeric').required('Câmp obligatoriu')
});
